import { jsx } from "react/jsx-runtime";
import CropIcon from "@mui/icons-material/Crop";
import { validateTidalLicense } from "../../base/index.js";
function Crop(props) {
  return /* @__PURE__ */ jsx(
    CropIcon,
    {
      "data-testid": "Crop",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "Crop",
      "data-tidal-icon-meta": "devices,photos"
    }
  );
}
Crop.tidalIconMeta = {
  categories: "devices,photos",
  name: "Crop"
};
validateTidalLicense();
export {
  Crop
};
//# sourceMappingURL=Crop.js.map
